import React from "react";

const If = ({ condition, children }) => {
  if (condition === false) return null;

  return <>{children}</>;
};

export default If;
